module.exports = __webpack_public_path__ + "static/media/books_and_news_paper.98c7299a.jpg";